import { EntityDetailView, EntityDetailPage } from "../../../common/entity/EntityDetailPage";
import { EntityDetailViewProps } from "../../../common/entity/EntityInterfaces";
import { EntityTablePage } from "../../../common/entity/EntityTablePage";
import { ZontalIPPDetail } from "./ZontalIPPDetail";
import { ZontalIPPTable } from "./ZontalIPPTable";

// Detail
export const ZontalIPPDetailView = ({ id }: EntityDetailViewProps<"zontalIPP">) => {
  return (
    <EntityDetailView id={id} entityTypeId={"zontalIPP"} filters={{}}>
      {(props) => <ZontalIPPDetail {...props} />}
    </EntityDetailView>
  );
};

export const ZontalIPPDetailsPage = () => {
  return <EntityDetailPage<"zontalIPP"> isIntId={false}>{(id) => <ZontalIPPDetailView id={id} />}</EntityDetailPage>;
};

export const ZontalIPPTablePage = () => {
  return <EntityTablePage entityTypeId={"zontalIPP"}>{(props) => <ZontalIPPTable {...props} />}</EntityTablePage>;
};
